export default __webpack_public_path__ + "static/media/22_mobile.fe443478.jpg";